import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { UserModule } from '@/store/modules/user'
import { menuBtn } from '@/utils/menu_level2_button'
import { getDeparmentList } from '@/api/common'
import { getProjectAllById, setProjectAllById } from '@/api/projectList'
import commonData from "@/utils/commonData";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import * as math from 'mathjs'

const projectTypeList = commonData.projectTypeAllArray
interface FormData {
    name: string;
    type: string;
    action: string;
    range: Array<any>;
    detail?: string;
    isDelete: number;
    userList: string[];
    departmentList: number[];
}
@Component({
    filters: {
        typeFilter: (val: number) => {
            const item = projectTypeList.filter(item => item.value === val)[0]
            return item ? item.label : ''
        }
    },
    components:{
        MoreUsersFilter
    }
})
export default class AllProjectInfo extends Vue {
    accessibleList: any = []
    rangeSelectShow = false
    inRange = '部门'
    checkRangeUserList: Array<string> = [] // 适用范围内选中的员工 id
    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    checkUserInfo: any = [] // 选中的员工信息，主要用来回显在适用范围的输入框内，与后台返回的deparmentList、userList数据结构基本一致，方便渲染
    checkDeparmentInfo: any = [] // 选中的部门信息
    formData: FormData = {
        name: '', // 名称
        type: '', // 类型
        action: '', // 动作
        range: [], // 适用范围
        detail: '', // 描述
        isDelete: 0,
        departmentList: [],
        userList: []
    }
    deparmentList: any = [] // 部门列表
    userListq = []
    userList1 = []
    userList2 = []
    userList3 = []
    loading = false
    searchName = '' // 搜索的关键字
    userListThesis = []
    userListHelper = []
    logShow = true
    logList = []
    formModelData = {
        quota: '',
    }

    quota_judge = false //满班是否显示
    doubleSouCourseName = ''
    showInput = false
    costList = [{ name: '', price: '' }]
    directorUserId = ''
    teacherUserId = ''
    thesisUserId = ''
    helperUserId = ''
    visualRange = '公开'
    visualUserList: string[] = []
    projectId: number = undefined
    infoData: any = {}
    projectAllShowUserList: any[] = []   //人员
    projectAllShowDepartmentList: any[] = []   //部门
    userType = ''
    formRules = {
        quota: [{required: true, message: '满班人数不能为空', trigger: ['blur', 'change']}],
    }
    userRealName = '' // 产品负责人name
    souCourseName = '' // 项目名称
    userNameList = []
    remark = ''


    get allCostNum() {
        let num = 0
        this.costList.forEach(item => { // num += item.price ? Number(item.price) : 0
                num = math.number(math.add(math.bignumber(num), math.bignumber(item.price ? Number(item.price) : 0)))
            }
        )
        return num
    }

    created() {
        if (this.$route.query.type === '1') {
            this.showInput = true
            this.getDeparment()
        }
        this.projectId = Number(this.$route.query.id)
        this.getProjectAllById()
        // this.getUserList()
    }


    formatDate = formatDate
    buttonShow = menuBtn

    // ------ 方法 ------
    // async getUserList(types?: string) {
    //     this.userList1 = []
    //     this.userList2 = []
    //     this.userList3 = []
    //     const data: any = await getUserList({ types })
    //     this.userList1 = data
    //     this.userList2 = data
    //     this.userList3 = data
    // }
    // remoteMethod(query) {
    //     if (query !== '') {
    //         this.loading = true
    //         setTimeout(() => {
    //             this.loading = false;
    //             // this.getUserList()
    //         }, 200)
    //     } else {
    //         this.userList1 = []
    //         this.userList2 = []
    //         this.userList3 = []
    //     }
    // }
    // handleTeacherUser(type) {
    //     this.getUserList(type)
    // }

    async getDeparment(name?: string) {
        const data: any = await getDeparmentList({ name })
        this.deparmentList = data
    }

    async getProjectAllById() {
        this.loading = true
        await getProjectAllById(this.projectId).then((data: any)=>{

        this.infoData = data.projectAll
        const { projectAllLogList, quota, projectAllShowUserList, projectAllShowDepartmentList,
            userId, teacherUserId, thesisUserId, helperUserId, projectAllCostList, isShow, doubleSouCourseName ,userRealName,
            souCourseName,remark} = data.projectAll
        this.costList = projectAllCostList ? projectAllCostList.length > 0 ? projectAllCostList : [{ name: '', price: '' }] : []
        this.logList = projectAllLogList
        this.doubleSouCourseName = doubleSouCourseName
        this.directorUserId = userId
        this.userRealName = userRealName
        this.souCourseName = souCourseName
        this.teacherUserId = teacherUserId
        this.thesisUserId = thesisUserId
        this.helperUserId = helperUserId
        this.userNameList = []
        if(projectAllShowUserList && projectAllShowUserList.length>0) projectAllShowUserList.map(item => {
            this.userNameList.push({
                id: item.userId,
                realName: item.userRealName,
                departmentName: item.userDepartmentName,
            })
        })


        // 2022-7-25置空班主任、小助手论文班主任的值
        // this.teacherUserId = ''
        // this.thesisUserId = ''
        // this.helperUserId = ''
        //判断 userList对象数组中的id是否含有5
        // const flag1 = this.userList1.some(item => item.id == this.teacherUserId);
        // const flag2 = this.userList2.some(item => item.id == this.thesisUserId);
        // const flag3 = this.userList3.some(item => item.id == this.helperUserId);
        // if (!flag1) {
        //     this.teacherUserId = ''
        // }
        // if (!flag2) {
        //     this.thesisUserId = ''
        // }
        // if (!flag3) {
        //     this.helperUserId = ''
        // }
        if(quota || quota == 0){
            // this.quota = quota ? quota : ''
            this.formModelData.quota = quota
            this.quota_judge = true
        }
        this.remark = remark ? remark : ''

        this.visualRange = isShow

        // projectAllShowDepartmentList.forEach((item) => {
        //     this.checkDeparmentInfo.push({
        //         department: {
        //           name: item.name,
        //           detail: null,
        //           id: item.id
        //         },
        //         departmentId: item.id
        //     })
        // })
        this.loading = false
        if (projectAllShowDepartmentList == undefined) {
            return
        } else {
            projectAllShowDepartmentList.map(item => {
                this.checkDeparmentInfo.push({
                    department: {
                        name: item.departmentName,
                        detail: null,
                        id: item.departmentId
                    },
                    departmentId: item.departmentId
                })
            })
        }
        projectAllShowUserList.map(item => {
            this.checkUserInfo.push({
                user: {
                    id: item.userId,
                    realName: item.userRealName
                },
                userId: item.userId
            })
        })
        this.checkRangeUserList = isShow === '共享人员' ? this.checkUserInfo.map(item => item.user.id) : []
        this.checkRangeDepartmentList = this.checkDeparmentInfo.map(item => item.department.id)
        this.projectAllShowUserList = isShow === '共享人员' ? projectAllShowUserList : []
        this.projectAllShowDepartmentList = isShow === '共享人员' ? projectAllShowDepartmentList : []

        }).catch(err=>{
            this.loading = false
        })
    }
    handleAddDeparment() {
        // this.getDeparment()
        this.rangeSelectShow = true
    }
    async onSearchName() {
        if (this.inRange === '部门') this.getDeparment(this.searchName)
    }

    clearRangeDeparmentItem(id: number) {
        const arr = []
        this.checkDeparmentInfo = this.checkDeparmentInfo.filter((item: any) => item.departmentId != id);
        for (const i in this.checkDeparmentInfo) {
            arr.push(this.checkDeparmentInfo[i].department)
        }
        (this.$refs.tree as HTMLFormElement).setCheckedNodes(arr)
    }

    changeInRange(type: string) {
        this.inRange = type
        this.searchName = ''
    }
    changeCheckUserInfo(item: { id: string; realName: string }, bol: boolean) {
        if (bol) {
            this.checkUserInfo.push({
                'userId': item.id,
                'user': item
            })
            this.checkUserInfo.map(item => {
                this.visualUserList.push(item.userId)
            })
        } else {
            this.checkUserInfo = this.checkUserInfo.filter(user => user.userId !== item.id)
        }
        this.formData.userList = this.checkUserInfo
    }

    clearRangeUserItem(id: string) {
        this.checkRangeUserList.splice(this.checkRangeUserList.indexOf(id), 1)
        this.checkUserInfo = this.checkUserInfo.filter((item: any) => item.user.id != id);
        this.userNameList = this.checkUserInfo.map(item => ({
            id: item.user.id,
            realName: item.user.realName,
            departmentName: item.user.departmentName,
        }))
        this.formData.userList = this.checkUserInfo
    }

    chooseDepartment(checkedKeys) {
        // 取消勾选
        const [accessibleList] = [this.accessibleList, (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        // 循环删除this.accessibleList中的项
        for (const i in accessibleList) {
            if (accessibleList[i].id == checkedKeys.id) {
                this.accessibleList.splice(i, 1);
                return;
            }
        }
        // 添加勾选
        const [arr, newArr] = [[], (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        arr.push(checkedKeys);
        function dealData(arr, newArr) {
            for (const i in arr) {
                newArr.push(arr[i].id);
                dealData(arr[i].children, newArr);
            }
        }
        // newArr代表获取出来的当前节点以及其下的所有子节点的id
        dealData(arr, newArr);
        (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
        // newJsonArr代表所有选中的节点
        const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
        this.accessibleList = newJsonArr;
        // this.checkDeparmentInfo = []
        newJsonArr.map(item => {
            this.checkDeparmentInfo.push({
                department: {
                    name: item.name,
                    detail: null,
                    id: item.id
                },
                departmentId: item.id
            })
        })
       /*
       * 去除相同id的数据
       * */
        this.checkDeparmentInfo = this.checkDeparmentInfo.filter((item, index, arr) => {
            return arr.findIndex(v => v.departmentId === item.departmentId) === index
        })
        this.checkDeparmentInfo.forEach((item) => {
            //动态向List中每个对象添加autoHeight属性
            this.$set(item, "autoHeight", "2rem");
        });
    }

    treeChange(item: any, itembol: boolean) {

        if (itembol) {
            const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
            const arrDeptId = []
            res.forEach((item) => {
                arrDeptId.push({
                    department: {
                        name: item.name,
                        detail: null,
                        id: item.id
                    },
                    departmentId: item.id
                })
            })
            /*
            * 拼接两个数组对象
            * */
            this.checkDeparmentInfo = this.checkDeparmentInfo.concat(arrDeptId)
            /*
            * 去掉id相同的数据
            * */
            this.checkDeparmentInfo = this.checkDeparmentInfo.filter((item, index, arr) => {
                return arr.findIndex((t) => t.departmentId === item.departmentId) === index
            })

        } else {
            //   this.checkRangeDepartmentList.splice(this.checkRangeDepartmentList.indexOf(item.id),1)
            this.checkDeparmentInfo.map((t: any, i: number) => {
                if (t.departmentId === item.id) {
                    this.checkDeparmentInfo.splice(i, 1)
                }
            });
        }
        this.formData.departmentList = this.checkDeparmentInfo
    }

    visualRangeChange() {
        if (this.visualRange !== '共享人员') {
            this.visualUserList = []
        }
    }
    delCostItem(index){
        this.costList.splice(index,1)
    }
    addCostItem() {
        this.costList.push({ name: '', price: '' })
    }
    handleFullClass(){
        if(this.quota_judge && this.infoData.haveQuota !== ''){
            this.infoData.surplusQuota = Number(this.formModelData.quota) - Number(this.infoData.haveQuota)
        }
    }
    async clickSubmit() {
        if (this.quota_judge && this.formModelData.quota === '') {
            this.$message.error('满班名额不能为空')
            return
        }
        if (this.quota_judge && this.infoData.haveQuota && (this.formModelData.quota < this.infoData.haveQuota)) {
            this.$message.error('满班名额不能小于报名人数')
            return
        }
        this.costList.forEach((item, index) => {
            if (!item.name && !item.price) {
                this.costList.splice(index, 1)
            }
        })
        const bol = this.costList.every(item => (item.name && item.price))
        if (!bol) {
            this.$message.error('请将项目成本明细填写')
            return
        }

        this.formData.range = [...this.checkRangeUserList, ...this.checkRangeDepartmentList];
        this.formData.userList = this.checkRangeUserList
        this.formData.departmentList = this.checkRangeDepartmentList
        const isShowDepartmentIdList = []
        this.checkDeparmentInfo.map(item => {
            isShowDepartmentIdList.push(item.departmentId)
        })
        const isShowUserIdList = []
        this.userNameList.map(item => {
            isShowUserIdList.push(item.id)
        })
        const param: any = {
            id: this.projectId,
            quota: this.formModelData.quota || this.formModelData.quota == '0' ? Number(this.formModelData.quota) : '',
            userId: this.directorUserId,
            teacherUserId: this.teacherUserId,
            thesisUserId: this.thesisUserId,
            helperUserId: this.helperUserId,
            projectAllCostList: this.costList,
            isShowUserIdList: isShowUserIdList,  //共享人id
            isShowDepartmentIdList: isShowDepartmentIdList,  //共享部门id
            doubleSouCourseName: this.doubleSouCourseName,
            isShow: this.visualRange,
            remark: this.remark,
        }
        if (this.visualRange !== '共享人员') {
            delete param.isShowUserIdList
            delete param.isShowDepartmentIdList
        }
        // if (this.inRange == '部门') delete param.isShowUserIdList
        // if (this.inRange == '员工') delete param.isShowDepartmentIdList
        if (!this.buttonShow) {
            delete param.projectAllCostList
        }
        for (const key in param) {
            if (key != 'doubleSouCourseName' && key != 'helperUserId'&& key != 'teacherUserId'&& key != 'thesisUserId'&& key != 'remark' && key !='quota') {
                if (!param[key] || param[key].length <= 0) {
                    delete param[key]
                }
            }
        }
        this.loading = true
        await setProjectAllById(param).then((data: any) => {
            this.$message.success('修改成功')
            this.loading = false
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch(err => {
            this.loading = false
        })
        // setTimeout(() => {
        //     window.close()
        // })
    }

    changeUser(e){
        this.directorUserId = e.id
    }

    changeCheckUser(e) {
        this.checkUserInfo = []
        if (e.array.length > 0) {
            e.array.map(item => {
                this.checkUserInfo.push({
                    'userId': item.id,
                    'user': item
                })
            })
            this.userNameList = e.array
        } else {
            this.userNameList = []
            this.checkUserInfo = []
        }
    }


    openSelectShow(){
        this.rangeSelectShow = true
    }
}
